import { toNumber } from "lodash";
import { useTranslation } from "react-i18next";
import {
    SECONDS_IN_DAY,
    SECONDS_IN_HOUR,
    SECONDS_IN_MINUTE,
} from "../../../../common/utils/date.utils";

export const useUplinkInterval = () => {
    const { t } = useTranslation("common");

    const getFormattedUplinkInterval = (value?: number) => {
        if (!value) {
            return;
        }

        const currentLabel = [];
        let lastingSeconds = toNumber(value);

        if (lastingSeconds >= SECONDS_IN_DAY) {
            const days = Number(lastingSeconds / SECONDS_IN_DAY).toFixed();
            currentLabel.push(`${days} ${t("common:days")}`);
            lastingSeconds -= Number(days) * SECONDS_IN_DAY;
        }

        if (lastingSeconds >= SECONDS_IN_HOUR) {
            const hours = Number(lastingSeconds / SECONDS_IN_HOUR).toFixed();
            currentLabel.push(`${hours} ${t("common:hours")}`);
            lastingSeconds -= Number(hours) * SECONDS_IN_HOUR;
        }

        if (lastingSeconds >= SECONDS_IN_MINUTE) {
            const minutes = Number(
                lastingSeconds / SECONDS_IN_MINUTE
            ).toFixed();
            currentLabel.push(`${minutes} ${t("common:min")}`);
            lastingSeconds -= Number(minutes) * SECONDS_IN_MINUTE;
        }

        return currentLabel.reverse().join(" ");
    };

    return { getFormattedUplinkInterval };
};
